import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface ReevaluateUserIdentityConflictsParams {
    ids: string[];
}

export class ReevaluateUserIdentityConflictsRequest extends Request<ReevaluateUserIdentityConflictsParams, IResult> {
  constructor(params: ReevaluateUserIdentityConflictsParams) {
    super('reevaluateUserIdentityConflicts', params);
  }
}
